import { NO_THANKS_OPTION, swissInsertsProductOsrs, requiredToDisplayFeatureOsrs } from '../constants'
import { getElementsByKey } from './index'

export const getCustomSizingSelectData = (subStepData, field) => {
    const productOsr = subStepData.product.productOsr
    const allAvailableFields = subStepData.product.features
    const isSwissInsertsProduct = swissInsertsProductOsrs.includes(productOsr)
    const showFieldOnPrevSelect = requiredToDisplayFeatureOsrs.includes(field.featureOsr)
    const isFirstElement = field.featureOsr === allAvailableFields[0]?.featureOsr
    const isSizeAndMaterialSubStep = subStepData.title === 'Size & Material'
    const selectOptions = (allAvailableFields?.length > 1 && !isSizeAndMaterialSubStep)
        ? [...field.options, NO_THANKS_OPTION]
        : field.options
    const isChosenOsrAvailable = subStepData.fields[field.featureOsr]?.chosenOsr

    const { previous } = getElementsByKey({
        objectsArray: allAvailableFields,
        key: 'featureOsr',
        value: field.featureOsr
    })

    const isPreviousChosenValue = (previous?.chosenValue && previous?.chosenValue !== NO_THANKS_OPTION.displayName)
    const isSwissInsertsValue = isSwissInsertsProduct && showFieldOnPrevSelect && previous.chosenValue
    const shouldDisplayCurrentSelectItem = isFirstElement || isPreviousChosenValue || isSwissInsertsValue || isChosenOsrAvailable

    return {
        selectOptions,
        shouldDisplay: shouldDisplayCurrentSelectItem
    }
}